import { types, successAction } from "@authzsvc/api-lib";

const initialState = {
  toApprove: [],
  my: [],
  fetchingOwner: false,
  activeOwner: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_REQUESTS):
      return {
        ...state,
        my: action.payload.data,
      };
    case successAction(types.GET_REQUESTS_TO_APPROVE):
      return {
        ...state,
        toApprove: action.payload.data,
      };
    default:
      return state;
  }
};
